/**
 * Create Experience Page
 *
 * Page for guides to create new outdoor experiences using the guided wizard.
 * Wraps the ExperienceCreationWizard component in a full-page layout.
 *
 * Epic: MVP 1.27 - Experience Creation Wizard
 * Location: apps/web/src/pages/CreateExperiencePage.jsx
 */

import React from 'react';
import ExperienceCreationWizard from '../../components/experiences/creation/ExperienceCreationWizard';

/**
 * Create Experience Page
 *
 * SCRUM-349: Removed SimplifiedHeader - wizard manages its own header with exit logic
 * The wizard includes "Save Draft & Exit" and X button with confirmation modal
 */
export default function CreateExperiencePage() {
  return (
    <ExperienceCreationWizard isNewExperience={true} />
  );
}
